import { COLORS, TYPE, SPACE } from '../tokens'
import SectionLabel from '../SectionLabel'
import FindingArticle from './FindingArticle'

export default function CoverageGaps({ findings, riskMap, dispositionMap, onSetDisposition, onSetEdits, locked }) {
  const gaps = (findings || []).filter(f =>
    f.finding_type === 'gap' && f.confidence_tier !== 'suppressed'
  )
  return (
    <section style={{ maxWidth: SPACE.sectionMaxWidth, margin: '0 auto' }}>
      <SectionLabel>Coverage gaps</SectionLabel>
      {gaps.length === 0 ? (
        <p style={{ ...TYPE.body, color: COLORS.mutedText }}>
          The Specialist did not surface any gaps that met the confidence floor.
        </p>
      ) : (
        gaps.map(f => (
          <FindingArticle
            key={f.id}
            finding={f}
            risk={riskMap?.[f.id]}
            disposition={dispositionMap?.[f.id]?.disposition}
            edits={dispositionMap?.[f.id]?.edits}
            onSetDisposition={(d) => onSetDisposition?.(f.id, d)}
            onSetEdits={(e) => onSetEdits?.(f.id, e, f)}
            locked={locked}
          />
        ))
      )}
    </section>
  )
}
